import apiClient from "services/apiClient";

async function createNotification(data: any) {
  const res = await apiClient.post(`/admin/reminders`, data);
  return res.data;
}

export default createNotification;
